import { atom } from 'recoil';

export const devToolsState = atom({
  key: 'devToolsState',
  default: {
    overridePhoneValidationApiCall: false,
    phoneValidationResult: 'success',
    overrideidValidationResult: false,
    validIdResult: 'Valid',
    duplicateIdResult: true,
    // ... add more boolean values as needed
  },
});
